import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProspectService } from 'services/prospect.service';
import { ProspectTourLocation } from 'app/models/prospect-tour-location';
import { ErrorService } from 'services/error.service';
import { SplashService } from 'services/splash.service';

@Component({
  selector: 'app-verify-location',
  templateUrl: './verify-location.component.html',
  styleUrls: ['./verify-location.component.css']
})
export class VerifyLocationComponent implements OnInit {
  loading: boolean = true;
  constructor(private router: Router, private prospectService: ProspectService, private errorService: ErrorService, private splashService: SplashService) {
   }

  ngOnInit() {
    this.checkForLocationAgreement();
    this.splashService.updateSplash("selftour");
  }

  findLocation() {
    this.loading = true;
    this.checkForLocationAgreement();
  }

  verifyLocation()
  {
    if (!navigator.geolocation) {
      this.loading = false;
      this.errorService.showError('Geolocation is not supported by your browser');
    } else {
      const options = {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      };

      navigator.geolocation.getCurrentPosition(res => this.postLocation(res), err => this.geoLocationError(), options);
    }
  }

  geoLocationError()
  {
    this.errorService.showError("We were unable to verify your location.");
    this.loading = false;
  }

  postLocation(position: any)
  {
    let tourKey = localStorage.getItem('SelfTourKey');

    if (tourKey === null || tourKey === undefined)
    {
      this.errorService.showError("Error pulling tour info.");
    }
    else {
      let location = new ProspectTourLocation();

      location.ProspectSelfTourKey = tourKey;
      location.Latitude = position.coords.latitude;
      location.Longitude = position.coords.longitude;

      this.prospectService.VerifyLocation(location).subscribe(res => this.onVerifyLocation(res), err => this.onVerifyLocationError(err));
    }
  }

  onVerifyLocation(verified: boolean) {
    if (verified)
    {
      this.router.navigate(['/tour/selftour-start/verify-identity']);
    }
    else {
      this.loading = false;
      this.errorService.showError("User is too far away from property.");
    }
  }

  onVerifyLocationError(err: any)
  {
    this.errorService.showError(err);
    this.loading = false;
  }

  checkForLocationAgreement()
  {
    this.prospectService.CheckForLocationAgreement().subscribe(res => this.onCheckForLocationAgreement(res), err => this.onVerifyLocationError(err))
  }

  onCheckForLocationAgreement(agreed: boolean)
  {
    if (agreed)
    {
      this.verifyLocation();
    }
    else {
      this.loading = false;
      this.errorService.showError("User did not agree to share location.");
    }
  }

}
